export enum SubstanceTypeEnum {
  BloodUrea = 'blood_urea',
  BloodUreaNitro = 'blood_urea_nitrogen',
}
